
import Vue from 'vue';
export default {
    scrollToTop: true,
    head() {
        return {
            title: this.title,
            meta: [{
                hid: 'og:title',
                property: 'og:title',
                content: this.title
            },
            {
                hid: 'twitter:title',
                property: 'twitter:title',
                content: this.title
            },
            {
            hid: 'description',
            name: 'description',
            content:'Explore the full details of Ashtavinayak "Shree Vighnahar Ganpati Temple Ozar" in English.'
          },
          {
            hid: 'og:description',
            property: 'og:description',
            content:'Explore the full details of Ashtavinayak "Shree Vighnahar Ganpati Temple Ozar" in English.'
          },
          {
            hid: 'twitter:description',
            property: 'twitter:description',
            content:'Shree Vighnahar Temple, Vighnahar Ganpati Ozar, Ashtavinayak Ganpati Ozar, Ozar Ganpati Temple, Vighnahar Vinayak Temple, Ashtavinayak Yatra Ozar, Vighnahar Ganesh Maharashtra, Ozar Ganpati Darshan, Ashtavinayak Pilgrimage Ozar'
          },
          {
            hid: 'keywords',
            name: 'keywords',
            content:'Shree Vighnahar Temple, Vighnahar Ganpati Ozar, Ashtavinayak Ganpati Ozar, Ozar Ganpati Temple, Vighnahar Vinayak Temple, Ashtavinayak Yatra Ozar, Vighnahar Ganesh Maharashtra, Ozar Ganpati Darshan, Ashtavinayak Pilgrimage Ozar, Vighnahar Temple History, ozar ganpati temple distance, ozar ganpati location, vighnahar ganpati ozar, ozar ganpati ashtavinayak, ozar ganpati temple timings' 
          },
          {
            hid: 'image',
            property: 'image',
            content: this.$config.siteUrl + '/img/ashtavinayak/vighnahar.webp'
          },
          {
            hid: 'og:image',
            property: 'og:image',
            content: this.$config.siteUrl + '/img/ashtavinayak/vighnahar.webp'
          },
        ],
    }
},

    components: {
    },
    data() {
        return {
            title: 'Shree Vighnahar Ganpati Temple Ozar | Ashtavinayak - श्री विघ्नेश्वर गणपती ओझर(अष्टविनायक)',
            langauageMarathi: true
        }
    },
    layout: 'detailsPage-withoutFooter',

    jsonld() {
    return {
      '@context': 'https://schema.org',
      "@graph": [{
        "@type": "Article",
        "mainEntityOfPage": {
          "@type": "WebPage",
          "@id": "https://goa.app/ashtavinayak/vighnahar"
        },
        "headline": "Shree Vighnahar Ganpati Temple Ozar - श्री विघ्नेश्वर गणपती ओझर(अष्टविनायक)",
        "name" : "Shree Vighnahar Ganpati Temple Ozar - Ashtavinayak",
        "description": "Explore the full details of Ashtavinayak 'Shree Vighnahar Ganpati Temple Ozar' in English.",
        "image": this.$config.siteUrl + '/img/ashtavinayak/vighnahar.webp',  
        "author": {
          "@type": "Organization",
          "name": "Goa App",
          "url": "https://goa.app"
        },  
        "publisher": {
          "@type": "Organization",
          "name": "Goa App",
          "logo": {
            "@type": "ImageObject",
            "url": "https://goa.app/android-chrome-384x384.png"
          }
        },
        "datePublished": "2024-10-10T08:00:00+08:00",
        "dateModified": "2024-10-10T09:20:00+08:00"
      },]}
    },

    computed: {

    },
    methods: {
        changeLanguage: function () {
            this.langauageMarathi = !this.langauageMarathi
        }
    }

}
